import React from "react";
import { fmtMoneyFull } from "../lib/format";
import { CurrencyDollar, Handshake, CheckCircle } from "@phosphor-icons/react";

const Card = ({ label, value, icon, tone, sub, testid }) => (
  <div className={`border rounded-sm p-4 ${tone === "hot" ? "border-emerald-500/40 bg-emerald-500/8" : tone === "escrow" ? "border-amber-500/40 bg-amber-500/8" : "border-blue-500/40 bg-blue-500/8"}`} data-testid={testid}>
    <div className="flex items-center justify-between mb-2">
      <div className="overline flex items-center gap-1.5" style={{ color: tone === "hot" ? "#10b981" : tone === "escrow" ? "#f59e0b" : "#3b82f6" }}>
        {icon} {label}
      </div>
    </div>
    <div className="mono text-2xl font-semibold tracking-tight" style={{ color: tone === "hot" ? "#6ee7b7" : tone === "escrow" ? "#fcd34d" : "#93c5fd" }}>
      {fmtMoneyFull(value || 0)}
    </div>
    {sub && <div className="mono text-[10px] text-zinc-500 mt-1">{sub}</div>}
  </div>
);

export default function RevenueHeader({ revenue, counts }) {
  const r = revenue || {};
  const c = counts || {};
  const inEscrowCount = (c.hot_deals || 0); // rough — leads with both signed
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4" data-testid="revenue-header">
      <Card
        label="Potential Profit"
        value={r.potential}
        icon={<CurrencyDollar size={12} weight="bold" />}
        tone="hot"
        sub={`${c.hot_deals || 0} HOT deals · sellers said YES`}
        testid="rev-potential"
      />
      <Card
        label="In-Escrow"
        value={r.in_escrow}
        icon={<Handshake size={12} weight="bold" />}
        tone="escrow"
        sub={`${inEscrowCount || 0} contracts signed · awaiting title`}
        testid="rev-escrow"
      />
      <Card
        label="Closed Deals (30d)"
        value={r.closed_30d}
        icon={<CheckCircle size={12} weight="bold" />}
        tone="closed"
        sub="Assignment fee · last 30 days"
        testid="rev-closed"
      />
    </div>
  );
}
